<template>
    <div class="score-table">
        <div v-if="isShow" class="table-content">
            <div class="mg-b-10 size18 ">
                成绩总排名
                <el-button type="danger" @click="toggleFullScreen">大屏</el-button>
            </div>           
            <el-table :data="tableData" class="custom-table custom-table2"  
                :row-class-name="tableRowClassName"
                style="width: 100%" border>
                <el-table-column prop="rank" label="名次" align="center" width="60px"/>                 
                <el-table-column prop="username" label="选手" align="center" width="110px"/> 
                <el-table-column prop="partnerName" label="搭档" align="center" width="110px" v-if="pubType ==='2'"/> 
                <el-table-column prop="company" label="协会(俱乐部)" align="center"/>
                <el-table-column v-for="(item,index) in roundLength " :key="item+'a'" :label="`第${index+1}轮`" align="center">            
                    <!-- <el-table-column label="对手"  v-if="pubType ==='2'" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].playersId2}}</template>
                    </el-table-column>  
                    <el-table-column label="同桌"  v-if="pubType === '1'" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].playersId}}</template>
                    </el-table-column> -->
                    <el-table-column label="得分" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].score}}</template>
                    </el-table-column> 
                    <el-table-column label="级差分" align="center">
                        <template slot-scope="scope">{{ scope.row.round[index].minus}}</template>
                    </el-table-column>  
                </el-table-column>     
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>
            </el-table> 
        </div>
        <!-- <div v-if="isShow" class="table-content" ref="printMe">
            <div class="mg-b-20 size18">成绩汇总表</div>
            <table>
                <thead>
                    <tr>
                        <th>名次</th>
                        <th>名称</th>
                        <th>编号</th>    
                        <td v-for="i in roundLength" :key="i"> 
                            第 {{ i }} 轮
                            <th v-if="pubType ==='2'" >对手</th>
                            <th v-else >同桌</th>
                            <th >得分</th>
                            <th >级差分</th>
                        </td>    
                        <th>积分</th>
                        <th>胜轮次</th>
                        <th>级差总分</th>
                        <th>升级数</th>
                        <th>搭档总分</th>    
                        <th>对手总分</th>                        
                        <th>搭档总级差分</th>            
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in tableData" :key="item.playersId">
                        <td>{{ item.rank }}</td>
                        <td>
                            <span>{{ item.username }}</span><span v-if="item.partnerName">/{{ item.partnerName }}</span></td>
                        <td>{{ item.playersId }}</td>
                        <td v-for="cell in item.round" :key="cell.round">
                            <div class="cell-section">{{cell.playersId}} </div>
                            <div class="cell-section">{{cell.score}}</div>
                            <div class="cell-section">{{cell.minus}}</div>
                        </td>
                        <td>{{ item.score }}</td>
                        <td>{{ item.winNum }}</td>
                        <td>{{ item.totalRank }}</td>
                        <td>{{ item.number }}</td>
                        <td>{{ item.partnerScore }}</td>
                        <td>{{ item.totalPlayers }}</td>                      
                        <td>{{ item.partnerRank }}</td>
                    </tr>
                </tbody>
            </table>
        </div> -->
        <!-- <el-button type="primary" @click="printPage">打印页面</el-button> -->
    </div>
 </template>
 
 <script>
import { mapState } from 'vuex'

 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     data() {
         return {
            dataList: [],
            tableData:[], 
            roundLength: 1, 
            errorMessage: '',
            isShow: false,
            tableHeaders: [
                {label: '积分', prop: 'score'},
                {label: '胜轮次', prop: 'winNum'},
                {label: '级差总分', prop: 'totalRank'},
                {label: '升级数', prop: 'number'},
                {label: '搭档总分', prop: 'partnerScore'},
                {label: '对手总分', prop: 'totalPlayers'},
                {label: '对手总级差分', prop: 'totalMinusPlayers'},               
                {label: '搭档总级差分', prop: 'partnerRank'},
            ],
         }
     },
     created() {
 
     },
     mounted() {
        
     },
     computed:{
        ...mapState(['round'])
     },
     methods: {  
        tableRowClassName({row, rowIndex}){
            // 前三名不同的颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        //赛事排名查看
        initData(){
            let params = {
                opcode: this.$code.RankScore,
                i_serial_mark: this.pubId,
             }            
             this.$api._requestAPI(params).then(async  res =>{
                 if (res.IsSuccess) {
                    
                    let result = res.Data.DataTable
                    let arr = result.map(item=>{                    
                        return{
                            playersId: item['选手编号'],
                            username: item['选手'],
                            rank: item['名次'],
                            score: item['积分'],
                            number: item['升级数'],                           
                            totalRank: item['级差总分'],
                            totalPlayers: item['对手总分'],
                            totalMinusPlayers: item['对手总级差分'],
                            partnerScore: item['搭档总分'],
                            partnerRank: item['搭档总级差分'],
                            partnerName: item['搭档'],
                            totalScore: item['累计分'],
                            winNum: item['胜轮次'],    
                            company: item['单位'],                        
                        }
                    })                    
                    
                    let newArr = [] 
                    for (const obj of arr) {
                        let roundList = await this.getRoundList(obj.playersId)
                        this.roundLength = roundList.length             
                        newArr.push({
                            round: roundList,
                            ...obj
                        })
                    }   
                    this.tableData = newArr
                    this.errorMessage = ''
                    this.isShow = true
                    let outputArry = this.$help.transformObjectToArrayTotal(result[0])
                    // 获取所有唯一的字段名
                    const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                    // 过滤出至少有一个非空值的字段
                    let filterArrNew= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));
                    this.dynamicHeaders = outputArry.filter(i=>filterArrNew.includes(i.prop))
                 }else{
                    this.isShow = false
                    this.errorMessage = res.Message
                    this.$message.error(res.Message)
                    
                 }
             })  
        },
        getRoundList(num){
            return new Promise((resolve,reject)=>{
                let params = {
                    opcode: this.$code.RankScorePartner,
                    i_serial_mark: this.pubId,
                    i_players_number: num
                }
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable  
                        let arr = result.map(item=>{
                            return{
                                round:item['轮数'],
                                playersId: item['同桌'],
                                playersId2: item['对手'],
                                score: item['成绩'],
                                rank: item['积分'],
                                minus: item['级差分'],
                            }
                        })
                        this.roundLength = arr.length
                        resolve(arr)
                    }
                })               
            })
        },
        getPlayerNum(num){
            let params = {
                opcode: this.$code.RankScorePartner,
                i_serial_mark: this.pubId,
                i_players_number: num
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable  
                    let arr = result.map(item=>{
                        return{
                            round:item['轮数'],
                            playersId: item['同桌'] || item['对手'],
                            score: item['成绩'],
                            rank: item['积分'],
                            minus: item['级差分'],
                        }
                    })
                    // this.roundLength = arr.length
                    // let newArr = []
                    // this.dataList.map(item=>{
                    //     newArr.push({
                    //         round: arr,
                    //         ...item
                    //     })
                    // })  
                    // this.tableData = newArr
                    // console.log('合并2个数组',newArr)  
                    // console.log('roundList', arr)    
                 }
             })   
         },  
         formatter(row, column, cellValue, index){
            // console.log(row,column,cellValue,index)
         },  
         printPage(){
            const printMe = this.$refs.printMe.innerHTML;
            // const style = `
            //     body {
            //     transform: scale(0.8);
            //     transform-origin: top left;
            //     }
            // `;
            // document.body.innerHTML = `<style>${style}</style>${printMe}`;
            window.print();
            document.body.innerHTML = '';
            // this.$print();
         },
         toggleFullScreen(){
            // this.$router.push({
            //     path: '/fullTotalTank',
            //     query: {
            //         id: this.pubId,
            //         type: this.pubType
            //     }
            // })
            const routeUrl = this.$router.resolve({ name: 'fullTotalTank', query: { id: this.pubId,type: this.pubType} });
            window.open(routeUrl.href, '_blank');          
        },     
     }
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 30px;
     margin-bottom: 20px;
 }
 .table-content{
    overflow: scroll;
 }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 18px;
   }
   tbody tr:hover{
        background-color:#f5f5f5
   }
//    tr:nth-child(even) {
//      background-color: lightblue;
//    }
   thead th {
     background-color: #f2f2f2;
     font-size: 16px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
   .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 18px;
    color: #333;
}
.custom-table >>> .gold-row{
    background-color: #FFD700;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
 </style>


// WEBPACK FOOTER //
// src/views/team/components/totalRank.vue